/* eslint-disable @typescript-eslint/no-explicit-any */
import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MobileService {
    public powerEvent = new EventEmitter<boolean>();

    public showMobileEvent = new EventEmitter<boolean>();

    public powerOn() {
        this.powerEvent.emit(true);
    }

    public powerDown() {
        this.powerEvent.emit(false);
    }

    public hideMobile() {
        this.showMobileEvent.emit(false);
    }

    public showMobile() {
        this.showMobileEvent.emit(true);
    }
}
